import {setAllowRedirect, showLoader} from "./appActions";
import {redirectTo, alertBackendError} from "../utils";
import { getUserOrganizations } from "../actions/resourceActions";
import fetch from "../utils/fetch";
import {RESOURCES} from "./constants";
import {getApiPrefix_touch} from "../constants";

export const createMyAtollonInstance = parametersAsStructure => async (dispatch, getState) => {
    dispatch(showLoader(true));
    try {


        const response = await fetch(`${getApiPrefix_touch()}/organization/asProduct`, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json"
            }),
            body: JSON.stringify(parametersAsStructure)
        });


        if (
            (response.status === 401 || response.status === 403) &&
            getState().app.allowRedirect
        ) {
            dispatch(setAllowRedirect(false));
            const url = await response.text();
            redirectTo(url);
            dispatch(showLoader(false));
        } else if (response.status === 500 || response.status === 503) {
            alertBackendError( {response} );
            dispatch(showLoader(false));
        }


        dispatch(showLoader(false));

        // refresh list with new data
        getUserOrganizations("related")(dispatch, getState);

        return response.status === 200;
    } catch (error) {
        console.log(error);
        alertBackendError( {error} );
        dispatch(showLoader(false));
        return false;
    }
};

export const addExistingAtollonInstance = parametersAsStructure => async (dispatch, getState) => {
    dispatch(showLoader(true));
    try {
        const response = await fetch(`${getApiPrefix_touch()}/organization/addExisting`, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json"
            }),
            body: JSON.stringify(parametersAsStructure)
        });

        if (
            (response.status === 401 || response.status === 403) &&
            getState().app.allowRedirect
        ) {
            dispatch(setAllowRedirect(false));
            const url = await response.text();
            redirectTo(url);
            dispatch(showLoader(false));
        } else if (response.status === 500 || response.status === 503) {
            alertBackendError({response});
            dispatch(showLoader(false));
        }

        dispatch(showLoader(false));

        // refresh list with new data
        getUserOrganizations("related")(dispatch, getState);

        return response.status === 200;
    } catch (exception) {
        console.log(exception);
        alertBackendError({exception});
        dispatch(showLoader(false));
        return false;
    }
};
// TODO:
export const getAvailablePackageListForAtollonInstance = atollonInstanceId => async (dispatch, getState) => {
    dispatch(showLoader(true));
    try {
        const urlPattern = `${getApiPrefix_touch()}/organization/{id}/package/product`;
        let url = urlPattern.replace("{id}",atollonInstanceId);
        const response = await fetch(url);

        if (
            (response.status === 401 || response.status === 403) &&
            getState().app.allowRedirect
        ) {
            dispatch(setAllowRedirect(false));
            const url = await response.text();
            redirectTo(url);
        } else if (response.status === 304) {
            // TODO: handle modified
            console.log('url:', url, ' modified');

        } else if (response.status === 200) {
            const content = await response.json();

            dispatch(showLoader(false));
            dispatch({
                type: RESOURCES,
                payload: { productsByOrganization: { [atollonInstanceId] : content }}
            });
        } else if (response.status === 500 || response.status === 503) {
            alertBackendError();
        }

        return response.status === 200;

    } catch (error) {
        console.log(error);
        alertBackendError();
        dispatch(showLoader(false));
        return false;
    }
};


// WEBPACK FOOTER //
// ./src/actions/organizationActions.js